<template>
  <v-dialog :value="open" max-width="790" width="530" @click:outside="clickOutside">
    <v-card class="dialog-box">
      <v-card-title class="headline" style="margin-bottom: 25px">
        {{ $t("ChangePassword") }}
      </v-card-title>

      <div class="inputs-container">
        <div class="password-input-container">
          <label for="password">
            {{ $t("CurrentPassword") + ":" }}
          </label>

          <input
            v-model="passwords.old_password"
            :type="showCurrentPassword ? 'text': 'password'"
            id="currentPassword"
            autocomplete="new-password"
            class="input-password"
          />
          <v-icon @click="setShowCurrentPassword" class="password-icon"> {{showCurrentPassword ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
        </div>

        <div class="password-input-container">
          <label for="password"> {{ $t("NewPassword") + ":" }} </label>

          <input
            v-model="passwords.new_password"
            @input="matchSecret"
            @change="validateSecret(passwords.new_password)"
            :type="showNewPassword ? 'text': 'password'"
            id="password"
            autocomplete="new-password"
            class="input-password"
            :class="{
              fieldErrorInput:
                validation.badPassword || validation.unmatchingPasswords
            }"
          />
          <v-icon @click="setShowNewPassword" class="password-icon"> {{showNewPassword ?' mdi-eye-off' : 'mdi-eye'}} </v-icon>
        </div>

        <div class="password-input-container">
          <label for="confirmPassword">
            {{ $t("ConfirmNewPassword") + ":" }}
          </label>

          <input
            v-model="passwords.new_password_confirmation"
            @input="matchSecret"
            :type="confirmNewPassword ? 'text': 'password'"
            id="confirmPassword"
            autocomplete="new-password"
            class="input-password"
            :class="{ fieldErrorInput: validation.unmatchingPasswords }"
            />
            <v-icon @click="setConfirmNewPassword" class="password-icon"> {{confirmNewPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
        </div>
      </div>

      <div v-if="validation.unmatchingPasswords" class="password-error-div">
        {{ $t("MatchingPasswords") }}
      </div>

      <div v-else-if="validation.badPassword" class="password-error-div">
        {{ $t("ValidPassword") }}
      </div>

      <v-card-actions style="margin-top: 25px">
        <management-button
          type="cancel"
          :label="$t('Cancel')"
          :disabled="loading"
          @buttonClick="closeDialog"
        />
        <management-button
          type="execute"
          :label="$t('Change')"
          :disabled="
            validation.unmatchingPasswords ||
              validation.badPassword ||
              !passwords.new_password ||
              !passwords.new_password_confirmation
          "
          @buttonClick="confirmChange"
          :is-loading="loading"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import utils from "@/utils";
import { mapActions } from "vuex";
import ManagementButton from "@/components/Management/ManagementButton";

export default {
  name: "ChangePasswordDialog",
  components: { ManagementButton },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      /**
       * Validation of mandatory fields
       */
      password: "",
        showCurrentPassword:false,
        showNewPassword:false,
        confirmNewPassword:false,

      passwords: {
        old_password: null,
        new_password: null,
        new_password_confirmation: null
      },

      validation: {
        badPassword: false,
        unmatchingPasswords: false
      },

      loading: false,


    };
  },

  computed: {
    currentUserUUID() {
      return this.$store.getters.currentUserUuid;
    }
  },

  methods: {
    ...mapActions(["changePassword"]),

    confirmChange() {
      this.loading = true;

      this.changePassword({
        uuid: this.currentUserUUID,
        data: this.passwords
      })
        .then(() => {
          this.loading = false;
          this.closeDialog();
          this.$toasted.global.toast_success(
            this.$i18n.t("UserEditedSuccessfully")
          );
        })
        .catch(error => {
          this.loading = false;
          this.handleError(error);
        });
    },

    closeDialog() {
      this.passwords.old_password = null;
      this.passwords.new_password = null;
      this.passwords.new_password_confirmation = null;
      this.$emit("close");
    },

    matchSecret() {
      this.validation.unmatchingPasswords =
        this.passwords.new_password !==
        this.passwords.new_password_confirmation;
    },

    validateSecret(value) {
      this.validation.badPassword = !utils.validatePassword(value);
    },

    handleError(error) {
      let errorHandle = utils.errorHandler(error);

      if (typeof errorHandle === "object") {
        if (errorHandle.hasOwnProperty("password")) {
          this.validation.badPassword = true;
        }
      } else if (typeof errorHandle === "string") {
        this.$toasted.global.toast_error(errorHandle);
      }
    },
    setShowCurrentPassword(){
      this.showCurrentPassword=!this.showCurrentPassword;
    },
    setShowNewPassword(){
      this.showNewPassword=!this.showNewPassword;
    },
    setConfirmNewPassword(){
      this.confirmNewPassword=!this.confirmNewPassword;
    },
    clickOutside() {
      this.closeDialog();
    }
  },
};
</script>

<style scoped>
.input-password {
  width: 150px;
  height: 32px;
  color: #515358;
  background-color: transparent;
  border: 1px solid #d7dadc;
  border-radius: 2px;
  padding: 0 8px;
}

.password-error-div {
  margin-top: 5px;
  margin-left: 100px;
  font-size: 10px;
  color: var(--red);
  white-space: nowrap;
}

.password-icon {
  bottom: 0 !important;
  position: relative !important;
  right: 0 !important;
}

.password-input-container {
  margin-bottom: 10px;
  width: 65%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 3px;
}

.inputs-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Navbar/UserWindow/ChangePasswordDialog.vue